@defer (on immediate) {
	<gallery [items]="pictures">
		<ng-template galleryItemDef let-item>
			<img galleryImage [src]="item.src" [alt]="item.alt">
		</ng-template>
	</gallery>
} @placeholder {
	<div class="visually-hidden">
		@for (picture of pictures; track picture.src) {
			<img [src]="picture.src" i18n-alt alt="lyo medical" loading="eager">
		}
	</div>
}
<mat-card>
	<mat-card-content class="index-content">
		<mat-card>
			<mat-card-header>
				<mat-card-title>
					<h1 class="app-36" i18n>Ven y vive la <span class="app-primary-color">Experiencia L&O Medical</span></h1>
				</mat-card-title>
			</mat-card-header>
			<mat-card-content class="centered app-20">
				<div class="home-img-container">
					<img ngSrc="images/home2.png" class="home-img" i18n-alt alt="lyo medical" fill priority>
				</div>
				<div>
					<p class="app-text-align-justify" i18n>
						En <b>L&O Medical</b>, brindamos modernas experiencias de estilo de vida, logrando satisfacer de manera integral las necesidades de <b>salud, belleza y bienestar de nuestros pacientes</b>.
					</p>
					<p class="app-text-align-justify" i18n>
						Esto lo logramos a través de nuestros servicios diseñados con los mejores <b>protocolos especializados</b> en atención al cliente, los mejores estándares de calidad, acompañados de la mejor tecnología de punta y un equipo de talento humano competente.
					</p>
					<p class="app-text-align-justify" i18n>
						Por eso en <b>L&O Medical</b>, manejamos varios campos específicos como <b>cirugía plástica, medicina estética, dermatología y odontología</b>, haciendo de nuestra clínica el mejor lugar donde encontrarás a los mejores especialistas médicos en un solo sitio, nuestro objetivo que vivas realmente la <b>verdadera experiencia</b> al mejor estilo de <b>L&O Medical</b>.
					</p>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-card class="app-elevation0">
			<mat-card-header>
				<mat-card-title class="app-36" i18n>
					Nuestros médicos
				</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="doctors-container">
					<div class="doctors-item">
						<h2 i18n>
							Consulta
							<br>
							Valoración
							<br>
							<br>
							$ 450,000 COP
						</h2>
					</div>
					<div class="doctors-item">
						<h2 i18n>Dra. Ana María Lopera</h2>
						<p i18n>Médica socia desde el año 2020</p>
						<h2 i18n>Dra. Valentina Lopera</h2>
						<p i18n>Médica socia desde el año 2020</p>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-card class="app-elevation0">
			<div class="home-specialty-container">
				<div class="home-specialty-item">
					<mat-icon class="app-150">health_and_safety</mat-icon>
					<h2 class="home-specialty-text"><b i18n>MÁS DE 8 ESPECIALIDADES</b></h2>
				</div>
				<div class="home-specialty-item">
					<mat-icon class="app-150">mark_email_unread</mat-icon>
					<h2 class="home-specialty-text"><b i18n>ATENCIÓN Y SERVICIO AL CLIENTE PERSONALIZADO</b></h2>
				</div>
				<div class="home-specialty-item">
					<mat-icon class="app-150">location_city</mat-icon>
					<h2 class="home-specialty-text"><b i18n>CÓMODAS Y NOVEDOSAS INSTALACIONES</b></h2>
				</div>
				<div class="home-specialty-item">
					<mat-icon class="app-150">work</mat-icon>
					<h2 class="home-specialty-text"><b i18n>CERTIFICADOS PROFESIONALES</b></h2>
				</div>
			</div>
		</mat-card>
	</mat-card-content>
</mat-card>
